import React, { createContext, useState, useEffect, useMemo } from 'react'
import { getTranslationMessages } from 'shared-ui'
import * as dateFnsLocales from 'date-fns/locale'
import LocalStorage from '../services/LocalStorage'

const LocaleContext = createContext()
export default LocaleContext

const messages = getTranslationMessages()

export function LocaleProvider(props) {

    const [locale, setLocale] = useState(LocalStorage.getItem('locale') || 'en')
    const [weekStart, setWeekStart] = useState(LocalStorage.getItem('weekStart') ?? 1)

    const datefnsLocale = useMemo(() => {
        const dateFnsLocaleName = locale.split('').filter(letter => letter !== '-').join('')
        return dateFnsLocales[dateFnsLocaleName]
    }, [locale])

    useEffect(() => {
        if (!locale) return
        LocalStorage.setItem('locale', locale)
    }, [locale])

    const localeMessages = useMemo(() => {
        return messages[locale]
    }, [locale])

    useEffect(() => {
        if (weekStart < 0 || weekStart > 6) return
        LocalStorage.setItem('weekStart', weekStart)
    }, [weekStart])

    return (
        <LocaleContext.Provider
            value={{
                locale,
                datefnsLocale,
                setLocale,
                locales: Object.keys(messages),
                localeMessages,
                weekStart,
                setWeekStart
            }}
            {...props}
        />
    )
}